import { BlockDefinition } from '../../types'
import { createEmptyRichText } from '../../richText/emptyContent'
import ImageTextBlock from './ImageTextBlock'

// Legacy equivalent: imagetext (also read by Next for faculty)
const imageTextBlock: BlockDefinition<'imageText'> = {
  type: 'imageText',
  createDefaultProps: () => ({
    source: null,
    width: null,
    height: null,
    alt: '',
    side: 'left',
    imageSize: 'standard',
    body: createEmptyRichText()
  }),
  Component: ImageTextBlock
}

export default imageTextBlock
